export const DEFAULT_STORE_INFOS = {
  FILE_EXCEL_IMPORT_EMPLOYEE: "/file/Import-employees.xlsx",
};
